export default __webpack_public_path__ + "static/media/show.3545e52a.svg";